import '../styles/Intro.css';

export function Intro({ intro }) {
  const logo = `img/${intro.img}`;
  return(
    <div className='columns is-desktop' id='intro'>
      <div className='column img-container'>
        <img className='image'
          src={logo}
        />
      </div>

      <div className='column'>
        <div >
          <h1 className='title is-1 bf-title ml-2'><strong>{intro.title}</strong></h1>
          <h3 className='subtitle is-3 bf-sub-title m-2'>{intro.text}</h3>
        </div>
      </div>
    </div>
  );
}